module.exports = {
      id: "premium-usage",
      viewBox: "0 0 576 512",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#premium",
      toString: function () {
        return this.url;
      }
    }